module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part-no",
    attrs: {
      "id": "pt-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("PART ONE")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h1', {
    staticClass: "part-title"
  }, [_c('strong', [_vm._v("Regulatory Exemptions Under the Constitution")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Part One addresses the right to religious exemptions from regulation under the Constitution. It is in two subsections — before "), _c('em', [_vm._v("Employment Division v. Smith")]), _vm._v(" in 1990, and after "), _c('em', [_vm._v("Employment Division v. Smith.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73df3c60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Part01.vue
// module id = 78
// module chunks = 0